import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { postSuggestion } from "../../redux/apiCalls/suggestionsCall/suggestionsCall";
import { Toast } from "../../helpers/alert";

const CLOUDINARY_URL = process.env.REACT_APP_CLOUDINARY_URL;
const UPLOAD_PRESET = process.env.REACT_APP_UPLOAD_PRESET;

const PostModal = ({ isOpen, setIsOpen }) => {
  const [issue, setIssue] = useState("");
  const [mesagge, setMesagge] = useState("");
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.currentUser);
  const intl = useIntl();

  const uploadToCloudinary = async (selectedFile) => {
    setIsUploading(true);

    const data = new FormData();
    data.append("file", selectedFile);
    data.append("upload_preset", UPLOAD_PRESET);
    data.append("folder", "Suggestions");

    try {
      const res = await fetch(CLOUDINARY_URL, {
        method: "POST",
        body: data,
      });
      const fileData = await res.json();
      setIsUploading(false);
      return fileData.secure_url;
    } catch (error) {
      console.error("Error al subir la imagen:", error);
      setIsUploading(false);
      return null;
    }
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files?.[0];
    if (selectedFile) {
      setFile(selectedFile);
    }
  };

  const handleClose = () => {
    setIssue("");
    setMesagge("");
    setFile(null);
    setIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      let imageUrl = null;

      if (file) {
        imageUrl = await uploadToCloudinary(file);
      }

      const data = {
        user: user?.mail,
        issue,
        mesagge,
        receiver: "Soporte Nabla",
        attach: imageUrl,
      };

      await postSuggestion(dispatch, user?.accessToken, data);

      setIssue("");
      setMesagge("");
      setFile(null);
      setIsOpen(false);

      Toast.fire({
        icon: "success",
        title: intl.formatMessage({
          id: "Message.Success",
          defaultMessage: "Mensaje enviado correctamente",
        }),
      });
    } catch (error) {
      console.error("Error creando sugerencia:", error);
      Toast.fire({
        icon: "error",
        title: intl.formatMessage({
          id: "Message.Error",
          defaultMessage: "No se pudo enviar el mensaje",
        }),
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div className="Modalsuggestions">
          <Modal
            show={isOpen}
            onHide={handleClose}
            centered
            dialogClassName="suggestions-modal-content"
          >
            <Modal.Header closeButton>
              <Modal.Title>Nueva consulta</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>
                    <FormattedMessage
                      id="PostModal.TopicLabel"
                      defaultMessage="Asunto"
                    />
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={issue}
                    onChange={(e) => setIssue(e.target.value)}
                    placeholder={intl.formatMessage({
                      id: "PostModal.EnterSubject",
                      defaultMessage: "Ingresa el asunto",
                    })}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    <FormattedMessage
                      id="PostModal.ConsultationLabel"
                      defaultMessage="Consulta"
                    />
                  </label>
                  <textarea
                    className="form-control"
                    value={mesagge}
                    onChange={(e) => setMesagge(e.target.value)}
                    rows="4"
                    placeholder={intl.formatMessage({
                      id: "PostModal.WriteQuery",
                      defaultMessage: "Escribe tu consulta aquí...",
                    })}
                    required
                  />
                </div>

                <div className="form-group">
                  <input
                    type="file"
                    id="fileInput"
                    className="d-none"
                    onChange={handleFileChange}
                  />

                  <label
                    htmlFor="fileInput"
                    className="btn btn-primary mt-2 btn-file-suggestions"
                  >
                    <FormattedMessage
                      id="SuggestionCard.SelectFile"
                      defaultMessage="Seleccionar archivo"
                    />
                  </label>

                  {file && !isUploading && (
                    <div style={{ marginTop: 10 }}>
                      <h5>
                        <FormattedMessage
                          id="PostModal.PreviewTitle"
                          defaultMessage="Vista previa"
                        />
                      </h5>

                      {file.type?.startsWith("image/") ? (
                        <img
                          src={URL.createObjectURL(file)}
                          alt="Vista previa"
                          style={{ width: "100%", marginTop: 10 }}
                        />
                      ) : (
                        <p style={{ marginTop: 10 }}>{file.name}</p>
                      )}
                    </div>
                  )}

                  {isUploading && (
                    <p>
                      <FormattedMessage
                        id="PostModal.Uploading"
                        defaultMessage="Subiendo imagen..."
                      />
                    </p>
                  )}
                </div>

                <Modal.Footer>
                  <Button
                    variant="secondary"
                    className="btn-close-suggestions"
                    onClick={handleClose}
                  >
                    <FormattedMessage
                      id="PostModal.CloseButton"
                      defaultMessage="Cerrar"
                    />
                  </Button>

                  <Button
                    type="submit"
                    className="btnSendSuggestions"
                    disabled={isUploading || isSubmitting}
                  >
                    <FormattedMessage
                      id="PostModal.PublishButton"
                      defaultMessage="Publicar"
                    />
                  </Button>
                </Modal.Footer>
              </form>
            </Modal.Body>
          </Modal>
        </div>
      )}
    </>
  );
};

export default PostModal;